import { cloneDeep } from 'lodash';

import { UsersRecord, UsersRecordExtended } from '../../../../../types/apiTypes';
import { OPTIMISTIC_NEW_USER_ID } from '../../../AdminUsersContainer';
import { User } from '../../../constants/user-roles';

export const upsertUsersOptimistic = (prevState: UsersRecordExtended[], newUsers: User[]) => {
    const upsertedEmails: string[] = [];

    const newOrUpdatedUsers = newUsers.map((newUser) => {
        const found = prevState.find((prevUser) => prevUser.email && prevUser.email?.toLowerCase() === newUser.email?.toLowerCase());

        if (found) {
            upsertedEmails.push(newUser.email);

            return {
                ...found,
                ...newUser,
                pendingChanges: true
            };
        }

        return {
            ...newUser,
            pendingChanges: true,
            user_id: OPTIMISTIC_NEW_USER_ID
        };
    });

    const unchangedUsers = cloneDeep(prevState).filter((prevUser) => {
        const updatedUser = upsertedEmails.find((email) => prevUser.email && email === prevUser.email);
        return !updatedUser;
    });

    const updatedRecords: UsersRecord[] = [...newOrUpdatedUsers, ...unchangedUsers].map((user) => {
        if ('name' in user) {
            return {
                user_name: user.name,
                email: user.email,
                pendingChanges: user.pendingChanges,
                user_id: user.user_id,
                roles: user.roles
            };
        }

        return user;
    });

    const updatedCount = upsertedEmails.length;
    const addedCount = newUsers.length - upsertedEmails.length;

    return {
        updatedRecords,
        updatedCount,
        addedCount
    };
};
